import Style from '../styles/RTMTableView.module.scss';
import { RTMTableViewProps } from '../types/RTMTypes';
import Table from '../../../CustomComponents/ReactTable/Table';
import { t } from 'i18next';

const RTMTableView = (props: RTMTableViewProps) => {
  return (
    <div className={Style.RTMTableView}>
      <div className='RTMTableView-container'>
        <Table name={'RealTimeMonitoring-table'} t={t} resize={true} columns={props.columns} rows={props.rows} pageSize={0} />
      </div>
    </div>
  );
};

export default RTMTableView;
